import React from 'react'
import { Box, Typography } from '@mui/material'

import Anchor from '@ecm/ui/element/Anchor'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'

const waysToHelp = [
  {
    heading: 'Call us between',
    icon: 'logomark',
    info: (
      <>
        8 a.m. and 5 p.m. CST <br /> at (866) 780-9880
      </>
    ),
  },
  {
    heading: 'Search our',
    icon: 'banker-box',
    link: [{ href: 'https://help.earthclassmail.com/hc/en-us', text: 'Library of help articles' }],
  },
  {
    heading: 'Email us at',
    icon: 'mail',
    link: [
      { href: 'mailto:support@earthclassmail.com', text: 'support@earthclassmail.com' },
      { href: 'mailto:sales@earthclassmail.com', text: 'sales@earthclassmail.com' },
    ],
  },
]

const NeedHelp = ({ message }: { message: string }) => (
  <Box bgcolor={Color.smoke.lightest} py="6em" textAlign="center">
    <MainContainer>
      <Typography variant="h3" component="h2" color={Color.saint.darker}>
        Need help?
      </Typography>
      <Typography variant="p2" mb="2em" color={Color.saint.darker}>
        {message} <b>contact us.</b>
      </Typography>
      <Box
        display="grid"
        gridTemplateColumns={{ md: 'repeat(3, 1fr)' }}
        gap={{ md: '5em', xs: '1em' }}
        m="0 auto"
        p={{ md: '3em 4em', xs: '3em 0' }}
        bgcolor={Color.white.normal}
        borderRadius="16px"
        maxWidth="lg"
        boxSizing="border-box"
      >
        {waysToHelp.map(({ heading, icon, info, link }) => (
          <Box key={heading}>
            <CloudflareImage src={`/images/icon/${icon}.svg`} width={72} height={72} />
            <Typography variant="p2" mb="0.5em">
              {heading}
            </Typography>
            {info && (
              <Typography variant="p3" fontWeight="700" color={Color.saint.darker}>
                {info}
              </Typography>
            )}
            {link &&
              link.map(({ text, href }) => (
                <Box key={text} sx={{ a: { padding: '0px 30px 0px 0' } }}>
                  <Anchor href={href} caret>
                    {text}
                  </Anchor>
                  <br />
                </Box>
              ))}
          </Box>
        ))}
      </Box>
    </MainContainer>
  </Box>
)

export default NeedHelp
